export default __webpack_public_path__ + "static/4-2e860bcbda0906915f4a70b52971daaf.jpeg";